import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBucket"><Path d="M4.2467 8.49805L5.5 20.5H18.5L19.7534 8.49805H4.2467Z" stroke="currentColor" strokeLinecap="round"/><Path d="M2.5 3.5H21.5V8.5H2.5V3.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconBucket;
